import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/support-page.scss';

initMainHeader();
